/**
 * Toggle / clear the task currently inspected in the agent-monitor rail.
 */
export function nextInspectedTaskId(
  current: string | null,
  clickedId: string,
): string | null {
  return current === clickedId ? null : clickedId;
}

export function inspectedIdAfterDelete(
  current: string | null,
  deletedId: string,
): string | null {
  return current === deletedId ? null : current;
}

export function inspectedIdAfterBulkDelete(
  current: string | null,
  deletedIds: ReadonlySet<string>,
): string | null {
  if (current && deletedIds.has(current)) return null;
  return current;
}
